import { Record } from 'immutable';
import { schema } from 'normalizr';

export const TestResult = new Record({
  id: undefined,
  name: undefined,
});

export const testResultSchema = new schema.Entity('testResults');

// for reading in nested models, object with { field: schema }
// testResultSchema.define({  });
